import React, { useState, useEffect } from 'react';
import './Testimonials.css';

// --- Icons ---
const ChevronLeft = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 18l-6-6 6-6" />
  </svg>
);
const ChevronRight = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 18l6-6-6-6" />
  </svg>
);
const SearchIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" />
  </svg>
);
const SettingsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const TESTIMONIALS_DATA = [
  {
    id: "UZMA-2022",
    name: "Ms. Uzma Khan",
    role: "Software Engineer at Capgemini",
    image: "./Testimonials/WhatsApp-Image-2021-10-27-at-10.19.17.jpeg", 
    quote: "TIMSCDR helped me in each step of my master's career. The placement division orchestrates an efficient process of getting students trained for jobs from technical skills, soft skills to weekly aptitude round tests. I would like to thank the Director, HOD, and the entire team for pushing us to improve.",
    tags: ["#MCA", "#Capgemini", "#PlacementSupport"]
  },
  {
    id: "TAUSIF-2022",
    name: "Tausif Khan",
    role: "MCA (2020-2022)",
    image: "./Testimonials/WhatsApp-Image-2021-10-27-at-10.18.39-165x165.jpeg",
    quote: "TIMSCDR is a good institute with better career opportunities and improving placements year by year. They provide teaching methodologies and modern equipment for better understanding of things in practical. Each department of this institute has honest and dedicated faculty.",
    tags: ["#MCA", "#Infrastructure", "#Faculty"]
  },
  {
    id: "RAHUL-2022",
    name: "Rahul Gupta",
    role: "SDE @ MountBlue Technologies",
    image: "./Testimonials/rahul-gupta-2-165x165.jpeg",
    quote: "The Institute provided me the best possible platform and infrastructure to pursue my career interest. The expert faculty made me industry ready, while the placement training helped me enhance my technical as well as soft skills. I was able to get an internship opportunity through college.",
    tags: ["#SDE", "#Internship", "#IndustryReady"]
  },
  {
    id: "ASHISH-2022",
    name: "Ashish Jaiswal",
    role: "System Engineer @ TCS",
    image: "./Testimonials/ashish-jaswal-165x165.jpeg",
    quote: "At TIMSCDR, I got the opportunity to participate in several competitions conducted by NASA, Nasscom, Microsoft, AICTE, and so many inter/intra college competitions. The faculty is like family and the Institute is like a second home.",
    tags: ["#TCS", "#Competitions", "#Mentorship"]
  },
  {
    id: "MAYURI-2021",
    name: "Ms. Mayuri Tiwari",
    role: "Associate Trainee at Chenoa Information",
    image: "./Testimonials/mayuri-tiwari-165x165.jpeg",
    quote: "Thank you for shaping me into the adult that I am today and for giving me professors that truly cared about my success and didn't see me as a number. Thank you for providing me with lifelong mentors.",
    tags: ["#CareerGrowth", "#Mentorship"]
  },
  {
    id: "BRIJESH-2009",
    name: "Mr. Brijesh Sah",
    role: "Senior Consultant @ PwC",
    image: "./Testimonials/testimonial1-165x165.jpg",
    quote: "The entire staff was very supportive and approachable. Class room trainings along with real-time case studies, industry best practices with examples and improving communication skills with constant interactions, were extremely useful.",
    tags: ["#PwC", "#Consulting", "#ProfessionalGrowth"]
  },
  {
    id: "RAJIV-2011",
    name: "Mr. Rajiv Singh",
    role: "Tech Head at GETPARKING",
    image: "./Testimonials/testimonial2-165x165.jpg",
    quote: "TIMSCDR is one of the important bases in my life. It provides the necessary freedom to explore your interest along with studies. A practical approach towards life and work is what I gained through this institute.",
    tags: ["#Leadership", "#PracticalLearning"]
  },
  {
    id: "ROIDON-2016",
    name: "Mr. Roidon Rodrigues",
    role: "Quality Assurance Engineer @ FIS GLOBAL",
    image: "./Testimonials/testimonial4-165x165.jpg",
    quote: "I had participated in the tech fest as a core committee member and during that time I was exposed to a leadership role which I believe has had a huge impact in my career today.",
    tags: ["#QA", "#Leadership", "#TechFest"]
  },
  {
    id: "MUZAMMIL-2017",
    name: "Mr. Muzammil Jafferi",
    role: "Engineer at Fractal Analytics",
    image: "./Testimonials/testimonial3-165x165.jpg",
    quote: "Taking admission in TIMSCDR was a perfect decision for me. TIMSCDR provides a great platform for learning and has helped me to develop a positive attitude towards my life & decision-making capacity in all aspects of my career.",
    tags: ["#DataAnalytics", "#DecisionMaking"]
  }
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isTyping, setIsTyping] = useState(false);

  const current = TESTIMONIALS_DATA[currentIndex];

  // Typewriter Logic
  useEffect(() => {
    let index = 0;
    setIsTyping(true);
    setDisplayText(''); // Reset text on change

    const intervalId = setInterval(() => {
      setDisplayText(current.quote.slice(0, index));
      index++;

      if (index > current.quote.length) {
        clearInterval(intervalId);
        setIsTyping(false);
      }
    }, 25); // Speed of typing

    return () => clearInterval(intervalId);
  }, [currentIndex, current.quote]);

  const nextSlide = () => setCurrentIndex((prev) => (prev === TESTIMONIALS_DATA.length - 1 ? 0 : prev + 1));
  const prevSlide = () => setCurrentIndex((prev) => (prev === 0 ? TESTIMONIALS_DATA.length - 1 : prev - 1));

  return (
    <div className="ta-page-wrapper">
      <div className="ta-isometric-overlay"></div>
      <div className="ta-main-content">
        <div className="ta-header">
          <div className="rs5865f2-titleWrap">
            <div className="rs5865f2-titleRow">
              <div className="rs5865f2-titlePlain">Our</div>
              <div className="rs5865f2-titleGradient">Testimonials</div>
            </div>
            <div className="rs5865f2-gradientLine" />
          </div>
          {/* <div className="ta-subtitle">// Stream: Encrypted_Data_Package...</div> */}
        </div>

        <div className="ta-terminal-container">
          <button className="ta-nav-btn ta-nav-prev" onClick={prevSlide}><ChevronLeft /></button>
          <button className="ta-nav-btn ta-nav-next" onClick={nextSlide}><ChevronRight /></button>

          <div className="ta-terminal-window">
            <div className="ta-scan-line"></div>
            <div className="ta-terminal-header">
              <div className="ta-header-left">
                <div className="ta-dot ta-dot-red"></div>
                <div className="ta-dot ta-dot-yellow"></div>
                <div className="ta-dot ta-dot-green"></div>
                <div className="ta-filename">system/logs/user_{current.id}.env</div>
              </div>
              <div className="ta-header-right"><SearchIcon /><SettingsIcon /></div>
            </div>

            <div className="ta-terminal-body">
              <div className="ta-line-numbers">
                01<br />02<br />03<br />04<br />05<br />06<br />07<br />08<br />09<br />10<br />11
              </div>

              <div className="ta-content-area">
                <div className="ta-profile-section">
                  <div className="ta-image-frame">
                    <img src={current.image} alt={current.name} />
                  </div>
                  <div className="ta-meta">
                    <div className="ta-role">{current.role}</div>
                    {/* Update the line below */}
                    <div className="ta-uuid">Batch: {current.id.split('-')[1]}</div>  </div>
                </div>

                <div className="ta-text-section">
                  <div className="ta-user-info">
                    <div className="ta-user-name">
                      {current.name} <span className="ta-method">.fetch()</span>
                    </div>
                    <div className="ta-accent-bar"></div>
                  </div>

                  <div className="ta-quote">
                    <span className="ta-quote-mark">"</span>
                    {displayText}
                    {isTyping && <span className="ta-cursor">|</span>}
                    <span className="ta-quote-mark">"</span>
                  </div>

                  <div className="ta-tags">
                    {current.tags.map((tag, i) => (
                      <span key={i} className="ta-tag">{tag}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ta-explore-section">
          <div className="ta-explore-title">REMOTE NODES</div>
          <div className="ta-explore-divider"></div>
          <div className="ta-thumbnail-grid">
            {TESTIMONIALS_DATA.map((item, index) => (
              <div
                key={item.id}
                className={`ta-thumb-wrapper ${index === currentIndex ? 'ta-thumb-active' : ''}`}
                onClick={() => setCurrentIndex(index)}
              >
                <div className={`ta-thumb-image ${index !== currentIndex ? 'ta-inactive' : ''}`}>
                  <img src={item.image} alt={item.name} />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="ta-status-bar">
          <div className="ta-status-item"><div className="ta-status-led"></div> SYNC_COMPLETE</div>
          <div className="ta-divider">|</div>
          <div className="ta-status-item">LOAD: {current.quote.length}bps</div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;